import Budget from "../../../models/Budget.js";
import RepositoryContext from "../../../core/repositories/RepositoryContext.js";
import session from "../../../core/session.js";

/**
 * Service used to automate budget filling with data from previous year's actual
 * data, with a percentage of income/cost growth variation.
 */
export default class BudgetAutomationService {
	constructor() {
		this._abortController = undefined;
	}

	async fillBudget({
		budget,
		fiscalYear,
		costGrowthPercentage,
		incomeGrowthPercentage,
	}) {
		this._abortController?.abort();

		let response;

		try {
			response = await this._fetch({
				budget,
				fiscalYear,
				costGrowthPercentage,
				incomeGrowthPercentage,
			});
		} catch {
			return budget;
		}

		return response.status === 200
			? this._materializeBudget(await response.json())
			: budget;
	}

	_fetch({
		budget,
		fiscalYear,
		costGrowthPercentage,
		incomeGrowthPercentage,
	}) {
		const url = `/Accounting2/Company/${session
			.getCompany()
			.getId()}/Budget/${budget.getId()}/BudgetAutomation/`;

		this._abortController = new AbortController();

		return fetch(url, {
			method: "PUT",
			signal: this._abortController.signal,
			headers: { "Content-Type": "application/json;charset=utf-8" },
			body: JSON.stringify({
				fiscalYearId: fiscalYear.getId(),
				costGrowthPercentage,
				incomeGrowthPercentage,
			}),
		});
	}

	_materializeBudget(data) {
		const context = new RepositoryContext();
		return Budget.materialize(data, context);
	}
}
